<template>
  <div class="mypooq-inner-wrap">
    <section>
      <!-- 패키지 리스트 영역 -->
      <div v-if="!!dataList.length" :class="editorModeClass">
        <div class="wrap">

          <!-- 상단 메뉴 -->
          <div class="my-purchase-edit-wrap">
            <button v-if="!isEditMode" class="my-purchase-edit" @click="editBtn()">
              <span>편집</span>
            </button>

            <ul v-if="isEditMode" class="my-purchase-edit-l">
              <li><button @click="selectedDelete()">선택삭제({{checkListLength}})</button></li>
              <li><button @click="allDelete" class="all-delete">전체삭제({{editModeTotalCount}})</button></li>
            </ul>

            <ul v-if="isEditMode" class="my-purchase-edit-r">
              <li><button @click="editBtn()">나가기</button></li>
            </ul>
          </div>

          <!-- 패키지 리스트 -->
          <template v-for="(packageItem, index) in dataList">
            <ul class="my-purchase-row" v-if="index % 2 === 0" :key="index">
                <voucher-package :data="dataList[index]"
                                 :index="index"
                                 :isEditMode="isEditMode"
                                 :ref="'package' + index+1"
                                 :set-check-fn="setCheck"/>
                <voucher-package :data="dataList[index+1]"
                                 :index="index+1"
                                 :isEditMode="isEditMode"
                                 :ref="'package' + index+1"
                                 :set-check-fn="setCheck"/>
            </ul>
          </template>
          <!-- 페이징 -->
          <paging-component :current-page="currentPage" :page-count="totalCount" :limit="limit" :paging-count="10" wrapper-class="paging-type02"/>
        </div>
      </div>

      <div v-if="!isLoading && dataList.length === 0" class="my-purchase-wrap">
      <div class="wrap">
        <empty-list text="패키지 구매 내역이 없어요."></empty-list>
      </div>
    </div>
    </section>
  </div>
</template>

<script>
import VoucherPackage from '@/components/mypooq/VoucherPackage'
import PagingComponent from '@/components/common/PagingComponent'
import { getMypurchaseContentsPackage, deleteMypurchaseContentsItem, deleteAllMypurchasePackage } from '@/common/utils/request'
import _ from 'lodash'
import EmptyList from '@/components/mypooq/EmptyList'
import { scrollTop, titleTagNameChange } from '@/common/utils/common'
import cookie from '@/common/utils/cookie'
import constant from '@/common/resources/constant'
export default {
  components: {
    VoucherPackage,
    PagingComponent,
    EmptyList
  },
  data () {
    return {
      isLoading: true,
      dataList: [],
      isEditMode: false,
      checkList: [], // 편집 모드에서 체크 된 리스트
      checkListLength: 0, // 편집 모드에서 체크 된 리스트 길이
      currentPage: 1,
      limit: 10,
      totalCount: 0,
      editModeTotalCount: 0,
      isPooqzone: cookie.isWavveOn(),
      settings: cookie.getAdultSettings()
    }
  },
  computed: {
    editorModeClass () {
      return this.isEditMode ? 'my-purchase-wrap editor-mode' : 'my-history-body'
    }
  },
  methods: {
    editBtn () {
      this.allCount()
      if (this.isEditMode) {
        this.$nextTick(() => {
          this.checkedReset()
        })
      }
      this.isEditMode = !this.isEditMode
      this.checkList = []
      this.checkListLength = 0
    },
    periodExpiration (endTime, data) {
      if (new Date(endTime.replace(/-/g, '/')) > new Date()) return false
      if (data) return data
      return true
    },
    allCount () {
      getMypurchaseContentsPackage({ offset: 0, limit: this.limit, dboption: 'master' }).then(({ data }) => {
        this.editModeTotalCount = Number(_.get(data, 'pagecount', '1'))
      })
    },
    setCheck (paymentId) {
      this.datalist = this.dataList.map((content) => {
        if (_.get(content, 'paymentid', '') === paymentId) {
          return _.set(content, 'checked', !_.get(content, 'checked', false))
        } else {
          return content
        }
      })
      this.checkList = []
      this.datalist.forEach((content) => {
        if (content.checked) {
          this.checkList.push(content.paymentid)
        }
      })
      this.checkListLength = this.checkList.length
    },
    initialization () {
      this.dataList = []
      this.checkList = []
      this.totalCount = 0
      this.checkListLength = 0
      this.setData()
    },
    purchaseContentsTypeInfo (selectedContentsList) {
      const isUnlimitedPeriod = selectedContentsList.filter((item) => _.get(item, 'isunlimitedperiod', 'n') === 'y').length > 0 // 영구소장 콘텐츠
      const isSalesExpired = selectedContentsList.filter((item) => _.get(item, 'issalesexpired', 'n') === 'y').length > 0 // 판권만료된 콘텐츠
      return { isUnlimitedPeriod, isSalesExpired }
    },
    deleteConfirm (isUnlimitedPeriod, isSalesExpired, deleteType) {
      if ((isUnlimitedPeriod && isSalesExpired) || isSalesExpired) {
        return confirm(deleteType === 'select'
          ? constant.MSG_CONFIRM_SELECT_DELETE_SALES_EXPIRED
          : constant.MSG_CONFIRM_ALL_DELETE_SALES_EXPIRED)
      } else if (isUnlimitedPeriod) {
        return confirm(deleteType === 'select'
          ? constant.MSG_CONFIRM_SELECT_DELETE_UNLIMITED_PERIOD
          : constant.MSG_CONFIRM_ALL_DELETE_UNLIMITED_PERIOD)
      } else {
        return true
      }
    },
    selectedDelete () {
      if (this.checkListLength === 0) return
      const { isUnlimitedPeriod, isSalesExpired } = this.purchaseContentsTypeInfo(this.dataList.filter((content) => content.checked))
      if (this.deleteConfirm(isUnlimitedPeriod, isSalesExpired, 'select')) {
        deleteMypurchaseContentsItem({ paymentId: this.checkList }).then(() => {
          this.initialization()
          setTimeout(() => {
            this.allCount()
          }, 1000)
        })
      }
    },
    callApiAllDelete () {
      deleteAllMypurchasePackage().then(({ data }) => {
        if (data.resultmessage === 'success') {
          this.initialization()
        }
      })
    },
    allDelete () {
      const { isUnlimitedPeriod, isSalesExpired } = this.purchaseContentsTypeInfo(this.dataList)
      if (!isUnlimitedPeriod && !isSalesExpired) {
        if (confirm('전체삭제를 진행하시겠습니까?' + this.totalCount + '건의 내역이 모두 삭제됩니다.')) {
          this.callApiAllDelete()
        }
      } else {
        if (this.deleteConfirm(isUnlimitedPeriod, isSalesExpired, 'all')) {
          this.callApiAllDelete()
        }
      }
    },
    setData () {
      this.isLoading = true
      scrollTop()
      this.currentPage = Number(_.get(this.$route, 'query.page', '1'))
      let offset = this.limit * (this.currentPage - 1)
      getMypurchaseContentsPackage({ offset, limit: this.limit, dboption: 'master' }).then(({ data }) => {
        this.dataList = _.get(data, 'list', [])
        this.dataList = this.dataList.map((data) => {
          return _.set(data, 'checked', false)
        })
        this.totalCount = Number(_.get(data, 'pagecount', '1'))
        this.isLoading = false
      })
    },
    checkedReset () {
      this.dataList = this.dataList.map((content) => {
        return _.set(content, 'checked', false)
      })
    }
  },
  created () {
    this.setData()
    titleTagNameChange('패키지 구매 : 웨이브 MY')
    this.$events.$on('checkPackage', (index, data) => {
      if (data) {
        this.checkList[index] = data
      } else {
        delete this.checkList[index]
      }
      this.checkListLength = Object.keys(this.checkList).length
    })
  },
  beforeDestroy () {
    this.$events.$off('checkPackage')
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/my.scss"></style>
<style lang="css">
.my-purchase-wrap .paging-type01{
  margin-top: 40px;
}
</style>
